import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';
import apiErrorFormatter from '../../services/apiErrorFormatter';
import { loadUser, saveUser, deleteUser } from '../../services/storage';

const user = loadUser();

const initialState = {
  user: user,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: [],
};

export const login = createAsyncThunk(
  'users/login',
  async ({ username, password }, thunkAPI) => {
    try {
      const response = await api.post('/users/login', {
        username,
        password,
      });

      if (response?.data?.accessToken) {
        saveUser(response.data);
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(apiErrorFormatter(error));
    }
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = [];
    },
    clearState: (state) => {
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = [];
    },
    setAccessToken: (state, action) => {
      state.user.accessToken = action.payload.accessToken;
      state.user.accessTokenExpires = action.payload.accessTokenExpires;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.user = null;
        state.isFetching = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = [];
      })
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
        state.isError = false;
        state.errorMessage = [];
      })
      .addCase(login.rejected, (state, action) => {
        // console.log('rejected action', action);
        state.user = null;
        state.isFetching = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export const { clearUser, clearState, setAccessToken } = userSlice.actions;

export const userSelector = (state) => state.user;

export const logout = () => async (dispatch) => {
  await api.post('/users/logout').then(
    (res) => {},
    (err) => {
      // const errors = apiErrorFormatter(err);
      // if (errors.length > 0) {
      //   errors
      //     .slice()
      //     .reverse()
      //     .map((error) => toast.error(t(error)));
      // }
    }
  );
  deleteUser();
  dispatch(clearUser());
};

export const updateAccessToken = (data) => (dispatch, getState) => {
  const currentUser = userSelector(getState().user);
  const newUser = { ...currentUser };
  newUser.accessToken = data.accessToken;
  newUser.accessTokenExpires = data.accessTokenExpires;
  saveUser(newUser);
  dispatch(setAccessToken(data));
};

export default userSlice.reducer;
